module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/catpd-9e0163529064bc2cbb2695115d8b060f.png";